import type { Environment } from "../../../types";
import {
  decodeDecreaseLiquidityResult,
  encodeDecreaseLiquidity,
} from "../v3-position-encoding";
import { ethCall, fetchCrossRpcUrl } from "./lp-balance-rpc-fallback";

/**
 * 출금 확정 전에 `decreaseLiquidity`를 RPC `eth_call`로 시뮬레이션해
 * 예상 수령량 (amount0, amount1)을 얻는다 (crossd remove-liquidity와 동일 접근).
 * min=0으로 호출하며, 반환값에 슬리피지를 적용하는 것은 호출부 책임.
 * RPC 조회/호출 실패 시 null — 호출부는 출금을 진행하지 않아야 한다.
 */
export async function simulateDecreaseLiquidity(
  env: Environment,
  args: {
    owner: string;
    positionManager: string;
    tokenId: bigint;
    liquidity: bigint;
    deadline: bigint;
  },
  signal?: AbortSignal,
): Promise<{ amount0: bigint; amount1: bigint } | null> {
  let rpcUrl: string | undefined;
  try {
    rpcUrl = await fetchCrossRpcUrl(env, signal);
  } catch {
    rpcUrl = undefined;
  }
  if (!rpcUrl) return null;

  const data = encodeDecreaseLiquidity({
    tokenId: args.tokenId,
    liquidity: args.liquidity,
    amount0Min: 0n,
    amount1Min: 0n,
    deadline: args.deadline,
  });
  const result = await ethCall(
    rpcUrl,
    args.positionManager,
    data,
    signal,
    args.owner,
  );
  return decodeDecreaseLiquidityResult(result);
}
